import { Cpu } from "lucide-react";

/**
 * ZFIndustries wordmark/logo.
 * Stylized: monospaced "ZF" with violet accent + chip icon.
 */
export default function Logo({ className = "" }) {
  return (
    <a
      href="#top"
      data-testid="brand-logo"
      className={`group inline-flex items-center gap-2.5 select-none ${className}`}
    >
      <span
        className="relative flex h-9 w-9 items-center justify-center rounded-md border border-violet-500/40 bg-violet-500/10 shadow-violet-soft transition-all group-hover:bg-violet-500/20"
        aria-hidden="true"
      >
        <Cpu className="h-5 w-5 text-violet-300" />
        <span className="absolute -inset-px rounded-md border border-transparent group-hover:border-violet-400/30" />
      </span>
      <span className="font-display text-[1.05rem] tracking-tight font-extrabold">
        <span className="text-white">ZF</span>
        <span className="text-violet-400 text-glow-violet">Industries</span>
      </span>
    </a>
  );
}
